import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import Checkbox from '@bibliocommons/deprecated-base-checkbox';
import { bindAll } from '@bibliocommons/utils-react';
import { Info } from '@bibliocommons/deprecated-base-icons';
import '../styles/DigitalAutoCheckouts.scss';

class EnableAutoCheckouts extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      helpIsOpen: this.props.initialHelpIsOpen,
      isChecked: this.props.initialIsChecked
    };

    bindAll(this);
  }

  toggleHelp(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState(state => ({ helpIsOpen: !state.helpIsOpen }));
  }

  toggleAutoCheckouts(checked) {
    this.setState(state => ({ isChecked: !state.isChecked }));
    this.props.handleChange(checked);
  }

  renderHelp() {
    const { intl } = this.props;
    if (this.state.helpIsOpen) {
      const helpInfo = intl.formatMessage({ id: 'enable_auto_checkout_info' });
      return (
        <div className="toggle-auto-checkouts-help" aria-expanded={this.state.helpIsOpen} aria-live="polite">
          {helpInfo}
        </div>
      );
    }
    return null;
  }

  render() {
    const { intl, supportAutoCheckout } = this.props;
    const helpInfoTriggerText = intl.formatMessage({ id: 'label_info' });
    const checkboxLabel = intl.formatMessage({ id: 'enable_auto_checkout' });

    if (supportAutoCheckout) {
      return (
        <div className="cp-digital-auto-checkouts">
          <Checkbox
            id="toggle-auto-checkouts"
            label={checkboxLabel}
            name="autoCheckout"
            checked={this.state.isChecked}
            inline
            handleChange={this.toggleAutoCheckouts}
          />
          <a href="#toggle-help" onClick={this.toggleHelp} className="toggle-help-trigger">
            <Info /> {helpInfoTriggerText}
          </a>
          {this.renderHelp()}
        </div>
      );
    }
    return null;
  }
}

EnableAutoCheckouts.defaultProps = {
  initialHelpIsOpen: false,
  initialIsChecked: false,
  supportAutoCheckout: false
};

const injectIntlPropTypes = {};

EnableAutoCheckouts.propTypes = {
  handleChange: PropTypes.func.isRequired,
  initialHelpIsOpen: PropTypes.bool,
  initialIsChecked: PropTypes.bool,
  supportAutoCheckout: PropTypes.bool,
  ...injectIntlPropTypes
};

export default injectIntl(EnableAutoCheckouts);
